import styled from "styled-components";

export const StyledTextBox = styled.div`
  position: relative;
  display: flex;
  .textbox {
    user-select: text;
    white-space: no-wrap;
    position: relative;
    word-break: break-word;
    border-radius: 26px;
    border: 0.5px solid rgba(0, 0, 0, 0.3);
    background-color: ${({ theme }) => theme.colors.card};
    width: 100%;
    min-height: 52px;
    max-height: 202px;
    overflow-y: auto;
    padding: 8px 50px 8px 16px;
    font-family: ${(props) => props.theme.typography.textsFont};
    font-size: 14px;
    font-style: normal;
    font-weight: 300;
    line-height: normal;
    box-sizing: border-box;
    box-shadow: ${({ theme }) =>
      theme.colors.background === "#171717"
        ? theme.boxShadows.dark
        : theme.boxShadows.light};
    :focus {
      outline: 1px solid black;
    }
    &::-webkit-scrollbar {
      display: none; /* Safari and Chrome */
    }
  }

  .textbox:before {
    content: attr(data-placeholder);
    position: absolute;
    top: 50%;
    left: 15px;
    transform: translateY(-50%);
    color: #999;
    display: none;
  }

  .textbox:focus:before {
    display: none;
  }

  .textbox:not(:focus):empty:before {
    display: block;
  }

  button {
    cursor: pointer;
    border-radius: 26px;
    border: 0.5px solid rgba(0, 0, 0, 0.3);
    background-color: ${({ theme }) => theme.colors.button};
    width: 44px;
    height: 44px;
    flex-shrink: 0;
    display: flex;
    align-items: center;
    justify-content: center;
    position: absolute;
    top: 4px;
    right: 4px;
  }
`;
